import { createMutationHook, createQueryHook } from "../factory";

const userKeys = {
  all: ["users"] as const,
  current: () => [...userKeys.all, "current"],
  tenantName: () => [...userKeys.current(), "tenantName"],
};

export const users = {
  createUser: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.users.createUser,
    mutationKey: ["users", "createUser"],
  }),
  getUserTenantName: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.users.getUserTenantName,
    queryKeyFn: userKeys.tenantName,
  }),

  sendUserOnboardNotification: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.users.sendUserOnboardNotification,
    mutationKey: ["users", "sendUserOnboardNotification"],
  }),

  setUserMfaPreference: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.users.setUserMfaPreference,
    mutationKey: ["users", "setUserMfaPreference"],
  }),
};
